<div class="pricing-table">
  <div class="pricing-table-top">
    <div class="pricing-table-top-container">
      <div class="pricing-table-top-item">
        <div class="plan-name" style="font-size: 16px;">Site Services </div>
      </div>
    </div>
    <div class="pricing-table-top-container">
      <div class="pricing-table-top-item">
        <div class="plan-name">Basic </div>
        <div class="current-badge" *ngIf="isCurrentPlan(1)">Current</div>
        <div class="next-badge" *ngIf="isNextMonthPlan(1)">Next</div>
      </div>
    </div>
    <div class="pricing-table-top-container">
      <div class="autolayout-col autolayout-fill-width">
        <div class="pricing-table-top-item"> 
          <div class="plan-name"> 
            <div class="plan-name-title">Video Vault </div>
          </div>
          <div class="current-badge" *ngIf="isCurrentPlan(2)">Current</div>
          <div class="next-badge" *ngIf="isNextMonthPlan(2)">Next</div>
        </div>
      </div>
    </div>
    <div class="pricing-table-top-container"> 
      <div class="autolayout-col autolayout-fill-width">
        <div class="pricing-table-top-item"> 
          <div class="plan-name"> 
            <div class="plan-name-title">Video Vault Plus</div>
          </div>
          <div class="current-badge" *ngIf="isCurrentPlan(3)">Current</div>
          <div class="next-badge" *ngIf="isNextMonthPlan(3)">Next</div>
        </div>
      </div>
    </div>
    <div class="pricing-table-top-container">
      <div class="autolayout-col autolayout-fill-width">
        <div class="pricing-table-top-item"> 
          <div class="plan-name"> 
            <div class="plan-name-title">Video Vault Plus AI</div>
          </div>
          <div class="current-badge" *ngIf="isCurrentPlan(4)">Current</div>
          <div class="next-badge" *ngIf="isNextMonthPlan(4)">Next</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pricing-table-services" *ngIf="!isCollapseTable">
    <!-- row-->
    <div class="services-container">
      <div class="services-item">
        <div>Free Monthly Event Storage</div>
      </div>
      <div class="services-item">
        <div>{{ currentSitePricing?.videoEvent?.free_package_amount?.event }} events</div>
      </div>
      <div class="services-item">
        <div>{{ currentSitePricing?.videoEvent?.free_package_amount?.event }} events (Good)</div>
      </div>
      <div class="services-item">
        <div>⭐ Unlimited</div>
      </div>
      <div class="services-item">
        <div>⭐ Unlimited</div>
      </div>
    </div>
    <!-- row-->
    <div class="services-container">
      <div class="services-item">
        <div>Unlimited Event Storage</div>
      </div>
      <div class="services-item"><i class="material-icons" style="color: red">close</i></div>
      <div class="services-item"><i class="material-icons" style="color: red">close</i></div>
      <div class="services-item">
        <div>⭐ Included</div>
      </div>
      <div class="services-item">
        <div>⭐ Included</div>
      </div>
    </div>
    <!-- row-->
    <div class="services-container">
      <div class="services-item">
        <div>Additional Video Events</div>
      </div>
      <div class="services-item">
        <ng-container *ngIf="isHasViewPricePermission">{{me?.currency_symbol}}{{ currentSitePricing?.videoEvent?.paid_package_amount?.price }} per {{ currentSitePricing?.videoEvent?.paid_package_amount?.event }} events</ng-container>
        <ng-container *ngIf="!isHasViewPricePermission">Pay based on usage</ng-container>
      </div>
      <div class="services-item">
        <ng-container *ngIf="isHasViewPricePermission">{{me?.currency_symbol}}{{ currentSitePricing?.videoEvent?.paid_package_amount?.price }} per {{ currentSitePricing?.videoEvent?.paid_package_amount?.event }} events</ng-container>
        <ng-container *ngIf="!isHasViewPricePermission">Pay based on usage</ng-container>
      </div>
      <div class="services-item">
        <div>⭐ Included</div>
      </div>
      <div class="services-item">
        <div>⭐ Included</div>
      </div>
    </div>
    <!-- row-->
    <div class="services-container">
      <div class="services-item">
        <div>24/7 Cloud Video Event Recording</div>
        <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"></div>
        <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'#55647B'"></comp-icon>
        <div class="--g-tooltip" style="text-transform: none">
          Dealers can enable continuous video event recording for each camera on the site. All events are stored in the CHeKT cloud, giving your customers instant access to their recordings at any time – <b>reducing technical support calls.</b><br/><br/>With cloud storage for all events, dealers can install applications without an onsite NVR, ensuring data redundancy and seamless access through CHeKT’s cloud. (Storage length is 90 or 365 days based on your dealer plan.)</div>
      </div>
      <div class="services-item"><i class="material-icons" style="color: red">close</i></div>
      <div class="services-item"><i class="material-icons icon-primary">check</i></div>
      <div class="services-item"><i class="material-icons icon-primary">check</i></div>
      <div class="services-item"><i class="material-icons icon-primary">check</i></div>
    </div>
    <!-- row-->
    <div class="services-container">
      <div class="services-item">
        <div>Video AI Filtering & Classification</div>
      </div>
      <div class="services-item"> <i class="material-icons" style="color: red">close</i></div>
      <div class="services-item"> 
        <div style="display: flex; flex-direction: column; text-align: center;"><i class="material-icons icon-primary">check</i></div>
      </div>
      <div class="services-item"> 
        <div style="display: flex; flex-direction: column; text-align: center;"><i class="material-icons icon-primary">check</i></div>
      </div>
      <div class="services-item"> 
        <div style="display: flex; flex-direction: column; text-align: center;"><i class="material-icons icon-primary">check</i></div>
      </div>
    </div>
    <!-- row-->
    <div class="services-container">
      <div class="services-item">
        <div>AI Filtering Costs</div>
      </div>
      <div class="services-item"><i class="material-icons" style="color: red">close</i></div>
      <div class="services-item">
        <div>Dealer-level usage fees apply</div>
      </div>
      <div class="services-item">
        <div>Dealer-level usage fees apply</div>
      </div>
      <div class="services-item">
        <div>⭐ Unlimited</div>
      </div>
    </div>
    <!-- row-->
    <div class="services-container">
      <div class="services-item">
        <div>Access to Camera SD Storage</div>
        <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')">
          <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'#55647B'"></comp-icon>
          <div class="--g-tooltip" style="text-transform: none">
            <div>For supported cameras, the Video Vault allows access to continuous recording on a camera's SD card, ensuring uninterrupted video recording capture.</div>
            <div>- Note: Storage length is based on SD card size and recording quality.</div>
          </div>
        </div>
      </div>
      <div class="services-item"><i class="material-icons" style="color: red">close</i></div>
      <div class="services-item"><i class="material-icons icon-primary">check</i></div>
      <div class="services-item"><i class="material-icons icon-primary">check</i></div>
      <div class="services-item"><i class="material-icons icon-primary">check</i></div>
    </div>
    <!-- row-->
    <div class="services-container">
      <div class="services-item">
        <div>Create Time-Lapse Recording</div>
        <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')">
          <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'#55647B'"></comp-icon>
          <div class="--g-tooltip" style="text-transform: none">
            Enable time-lapse recording for individual cameras or all cameras at a site. Each time-lapse video compiles snapshots taken every 10 seconds into a <b>1-hour MP4 file</b>, allowing users to quickly review extended periods.<br/><br/>Time-lapse videos are generated every hour, allowing users to quickly review extended periods or share condensed footage through the CHeKT mobile app or browser portal.</div>
        </div>
      </div>
      <div class="services-item"><i class="material-icons" style="color: red">close</i></div>
      <div class="services-item"><i class="material-icons" style="color: red">close</i></div>
      <div class="services-item"><i class="material-icons icon-primary">check</i></div>
      <div class="services-item"><i class="material-icons icon-primary">check</i></div>
    </div>
  </div>
  <div class="collapse-button" (click)="collapseButton()" *ngIf="!isFixedOpen && isShowCollapseButton">
    <div>{{ isCollapseTable ?  'Quick View' : 'Detailed View' }}</div><i class="material-icons">{{ isCollapseTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </i>
  </div>
</div>